export default __webpack_public_path__ + "static/media/close.0e28b9eb.svg";